<template>

  <v-breadcrumbs :items="breadcrumbs" v-if="agentDataLoadingStatus == 'loaded' && userDataListLoadingStatus == 'loaded'">
    <template v-slot:item="{ item, index }">
      <v-breadcrumbs-item
        :to="item.href"
        :disabled="item.disabled"
        :exact="(index==0) ? true : false"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>

  </v-breadcrumbs>

</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "Breadcrumbs",
  components: {},
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
    ...mapGetters({
      userDataList: 'users/userDataList',
      userDataListLoadingStatus: 'users/userDataListLoadingStatus',
      agentData: 'resources/agentData',
      agentDataLoadingStatus: 'resources/agentDataLoadingStatus',
    }),
    userName() {
      if (this.$route.params.user_id == 0) return "All Users"
      const user = this.userDataList.find(user => user.userid == parseInt(this.$route.params.user_id))
      const first = user.firstname || "";
      const last = user.lastname || "";
      return first || last
        ? `${first} ${last}`.trim()
        : "Unknown User";
    },
    agentName() {
      const agent = this.agentData.find(agent => agent.id == parseInt(this.$route.params.agent_id))
      return agent
        ? `${agent.name}`.trim()
        : "Unknown Agent";
    },
    breadcrumbs() {

      let crumbs = []
      crumbs.push(        {
          text: 'Coaching Summary',
          disabled: false,
          href: '/task-summary/',
        },
      )

      if(this.$route.params.hasOwnProperty('user_id')) {
        let taskSummRoute = this.$route.params.user_id == 0 ? '/task-summary-all/' : '/task-summary/'
        crumbs.push(        {
            text: this.userName,
            disabled: false,
            href: taskSummRoute + this.$route.params.user_id + '/agents/',
          },
        )
      }

      if(this.$route.params.hasOwnProperty('agent_id')) {
        crumbs.push(        {
            text: this.agentName,
            disabled: false,
            href: '/task-summary/' + this.$route.params.user_id + '/agents/'  + this.$route.params.agent_id,
          },
        )
      }

      return crumbs

    }
  },
  mounted() {
  },
  watch: {
  }
};

</script>

<style scoped>

</style>
